import { Link } from "react-router-dom";

// Typographic monogram tile — deliberately NOT a brand logo, to reinforce that
// we are independent and not affiliated with the brand.
export function BrandMark({ name, color = "#1A1A19", size = "md" }) {
  const initial = (name || "?").trim().charAt(0).toUpperCase();
  const dims =
    size === "lg" ? "h-16 w-16 text-2xl" : size === "sm" ? "h-9 w-9 text-sm" : "h-12 w-12 text-lg";
  return (
    <span
      aria-hidden="true"
      className={`inline-flex ${dims} shrink-0 items-center justify-center border font-serif font-semibold`}
      style={{ borderColor: color, color }}
    >
      {initial}
    </span>
  );
}

export default BrandMark;
